<template>
  <div
    class="access-denied-error"
    style="background-color: #f6f8fb;">
    <el-card class="error_container">

      <div
        class="mx-24 my-24 el-text el-text--display-medium"
        style="text-align: center;">
        {{ $t('error.root-admin-login.title') }}
      </div>

      <div
        class="mx-24 mb-24"
        style="text-align: center;">
        Access denied
      </div>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AccessDeniedError'
};
</script>

<style lang="scss" scoped>
  .access-denied-error {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error_container {
    width: 512px;
  }
</style>
